import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  bills: 'Bills',
  batchBills: 'BatchBills',
  inboundTickets: 'InboundTickets',
  outboundTickets: 'OutboundTickets',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.bills, TAG_TYPES.batchBills, TAG_TYPES.inboundTickets, TAG_TYPES.outboundTickets],
  endpoints: {
    getBills: {
      providesTags: result =>
        result && result.length > 0
          ? // successful query
            [
              ...result.map(bill => ({
                type: TAG_TYPES.bills,
                id: bill.id,
              })),
              { type: TAG_TYPES.bills, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'Bills', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.bills, id: 'LIST' }],
    },
    getBill: {
      providesTags: (result, error, { billId }) => [{ type: TAG_TYPES.bills, id: billId }],
    },
    updateBill: {
      invalidatesTags: (result, error, { billId }) => [
        { type: TAG_TYPES.bills, id: 'LIST' },
        { type: TAG_TYPES.bills, id: billId },
      ],
    },
    mergeBill: {
      invalidatesTags: (result, error, { billId, body, inboundTicketIds, outboundTicketIds }) => [
        { type: TAG_TYPES.bills, id: 'LIST' },
        { type: TAG_TYPES.bills, id: billId },
        ...(body?.billIds || []).map(id => ({ type: TAG_TYPES.bills, id })),
        ...(inboundTicketIds || []).map(id => ({ type: TAG_TYPES.inboundTickets, id })),
        ...(outboundTicketIds || []).map(id => ({ type: TAG_TYPES.outboundTickets, id })),
      ],
    },
    updateAndMergeBill: {
      invalidatesTags: (result, error, { billId, inboundTicketIds, outboundTicketIds }) => [
        { type: TAG_TYPES.bills, id: 'LIST' },
        { type: TAG_TYPES.bills, id: billId },
        ...(inboundTicketIds || []).map(id => ({ type: TAG_TYPES.inboundTickets, id })),
        ...(outboundTicketIds || []).map(id => ({ type: TAG_TYPES.outboundTickets, id })),
      ],
    },
    voidBill: {
      invalidatesTags: (result, error, { billId, batchBillId, inboundTicketIds, outboundTicketIds }) => [
        { type: TAG_TYPES.bills, id: 'LIST' },
        { type: TAG_TYPES.bills, id: billId },
        ...(batchBillId
          ? [
              { type: TAG_TYPES.batchBills, id: 'LIST' },
              { type: TAG_TYPES.batchBills, id: batchBillId },
            ]
          : []),
        ...(inboundTicketIds || []).map(id => ({ type: TAG_TYPES.inboundTickets, id })),
        ...(outboundTicketIds || []).map(id => ({ type: TAG_TYPES.outboundTickets, id })),
      ],
    },
    getFreightBills: {
      providesTags: [
        { type: TAG_TYPES.inboundTickets, id: 'LIST' },
        { type: TAG_TYPES.outboundTickets, id: 'LIST' },
        { type: TAG_TYPES.bills, id: 'LIST' },
      ],
    },
  },
})

export const {
  useGetBillsQuery,
  useGetBillQuery,
  useUpdateBillMutation,
  useMergeBillMutation,
  useUnmergeBillMutation,
  useUpdateAndMergeBillMutation,
  useVoidBillMutation,
  useGetFreightBillsQuery,
} = api
